const LINE_KEY_STORAGE: string = 'line_expiry_time';
const LINE_REDIRECT_URL: string = 'line_redirect_url';
const LINE_QUERY_STRING: string = 'line-user-id';

export { LINE_KEY_STORAGE, LINE_REDIRECT_URL, LINE_QUERY_STRING };
